<template>
  <div class="mb-10">
    <!--v-if-->
    <h3 class="card-title align-items-start flex-column pb-3">
      <span class="card-label page-title fw-bolder fs-3 mb-1"
        >Add Worker</span
      >
    </h3>
    <div class="card">
      <div class="card-body py-10">
        <div class="tab-content">
          <!--begin::Tap pane-->
          <div class="tab-pane fade show active" id="kt_table_widget_5_tab_1">
            <form @submit.prevent="createUserConfirmation">
              <div class="row">
                <div class="fv-row mb-10 fv-plugins-icon-container col-6">
                  <label class="d-flex align-items-center fs-5 fw-bold mt-6"
                    ><span class="required">First Name</span
                    ></label
                  ><!--end::Label--><!--begin::Input--><input
                    type="text"
                    v-model="user.firstName"
                    class="form-control form-control-lg form-control-solid"
                  /><!--end::Input-->
                </div>
                <div class="fv-row mb-10 fv-plugins-icon-container col-6">
                  <!--begin::Label--><label
                    class="d-flex align-items-center fs-5 fw-bold mt-6"
                    ><span class="required">Last Name</span
                    ></label
                  ><!--end::Label--><!--begin::Input--><input
                    v-model="user.lastName"
                    class="
                      custom-select
                      form-control form-control-lg form-control-solid
                    "
                  />
                </div>
              </div>
              <div class="row">
                <div class="fv-row mb-10 fv-plugins-icon-container col-6">
                  <!--begin::Label--><label
                    class="d-flex align-items-center fs-5 fw-bold mt-6"
                    ><span class="required">Email</span
                    ></label
                  ><!--end::Label--><!--begin::Input--><input
                    v-model="user.email"
                    class="form-control form-control-lg form-control-solid"
                  />
                  <!--end::Input-->
                  <div
                    class="fv-plugins-message-container invalid-feedback"
                  ></div>
                </div>
                <div class="fv-row mb-10 fv-plugins-icon-container col-6">
                  <!--begin::Label--><label
                    class="d-flex align-items-center fs-5 fw-bold mt-6"
                    ><span class="required">Company</span
                    ></label
                  ><!--end::Label--><!--begin::Input--><input
                    v-model="user.company"
                    class="form-control form-control-lg form-control-solid"
                  />
                  <!--end::Input-->
                  <div
                    class="fv-plugins-message-container invalid-feedback"
                  ></div>
                </div>
              </div>

              <div class="row">
                <div class="fv-row mb-10 fv-plugins-icon-container col-6">
                  <!--begin::Label--><label
                    class="d-flex align-items-center fs-5 fw-bold mt-6"
                    ><span class="required">Regular Access</span
                    ><i
                      class="fas fa-exclamation-circle ms-2 fs-7"
                      data-bs-toggle="tooltip"
                      v-b-tooltip.hover
                    ></i></label
                  ><!--end::Label--><!--begin::Input--><input
                    type="radio"
                    value="worker"
                    v-model="user.role"
                  /><!--end::Input-->
                  <div
                    class="fv-plugins-message-container invalid-feedback"
                  ></div>
                </div>
                <div class="fv-row mb-10 fv-plugins-icon-container col-6">
                  <!--begin::Label--><label
                    class="d-flex align-items-center fs-5 fw-bold mt-6"
                    ><span class="required">Admin Access</span
                    ><i
                      class="fas fa-exclamation-circle ms-2 fs-7"
                      data-bs-toggle="tooltip"
                      v-b-tooltip.hover
                    ></i></label
                  ><!--end::Label--><!--begin::Input--><input
                    type="radio"
                    value="admin"
                    v-model="user.role"
                  /><!--end::Input-->
                  <div
                    class="fv-plugins-message-container invalid-feedback"
                  ></div>
                </div>
              </div>
              <button
                type="submit"
                :class="createUserBtnClass"
                data-bs-toggle="modal"
                data-bs-target="#kt_modal_confirm"
              >
                Create User
                <span v-if="loading"
                  class="spinner-border spinner-border-md align-middle ms-2"
                ></span>
                <svg
                  v-if="!loading"
                  width="22"
                  height="23"
                  viewBox="0 0 22 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M7.04956 11.6921H14.9056"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </button>
            </form>
            <div class="spacer-y-10"></div>
            <div class="spacer-y-10"></div>
          </div>
        </div>
      </div>
      <!--end::Body-->
    </div>
    <ConfirmationModal
      :isLoadingConfirmation="loadingConfirmation"
      :isShowDialog="isShowConfirmationModal"
      :btnConfig="buttonConfiguration"
      :inputInfo="confirmationModalInfo"
      :inputColor="confirmationModalInfoColor"
      @eConfirm="createUser"
      @eCancel="defaultCancelOperation"
    />
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </div>
</template>

<script>
import { error } from "@/services/LoggerService";
import { ApiService } from "@/services/ApiService";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import mixins from "vue-typed-mixins";

export default mixins(ConfirmationModalMixin,SnackbarNotifierMixin).extend({
  name: "AddWorker",
  data() {
    return {
      loading: false,
      user: { firstName: "", lastName: "", email: "", role: "", company: "" },
    };
  },
  components: {
    ConfirmationModal,
    SnackbarNotifier
  },
  computed: {
    userFullName(){
      return `${this.user.firstName} ${this.user.lastName}`;
    },
    createUserBtnClass(){
      const defaultClass = "btn fw-bold px-6 py-5 w-100 mb-4 mt-6";
      if(!this.user.firstName || !this.user.lastName || !this.user.email || !this.user.role || !this.user.company || this.loading) return `${defaultClass} btn-secondary disabled`;
      return `${defaultClass} btn-primary`;
    }
  },
  methods: {
    renameUser(role){
      if(role.toLowerCase() === 'worker') return 'regular';
      return role;
    },
    createUserConfirmation(){
      let role = this.user.role.toLowerCase() === 'admin'
        ? `<b style="color:red"><em>${this.user.role.toUpperCase()}</em></b>`
        : `<b><em>${this.renameUser(this.user.role).toUpperCase()}</em></b>`;


      this.showConfirmationModal({
        title: 'Create New User',
        message: `Are you sure you want to add <b><em>${this.userFullName}</em></b> with ${role} role?`
      });
    },
    async createUser() {
      try {
        this.loading = true;
        this.startConfirmationLoading();
        var result = await ApiService.Instance.createUser(this.user);
        if (result){
          this.showNotifier({
            message: `Successfully Add ${this.userFullName}`,
            snackbarType: 'success'
          });
          this.user = {};
        }
        this.loading = false;
        this.stopConfirmationLoading();
      } catch (e) {
        this.showNotifier({
          message: `Failed To Add ${this.userFullName}`,
          snackbarType: 'error'
        });
        this.stopConfirmationLoading();
        this.loading = false;
        error(e);
      }
    },
  },
});
</script>

<style></style>
